const componentDomIds = {
  customer: {
    temporaryNavigationDrawer: {
      RIGHT_SIDE_BAR: 'temporary_nav_drawer_side_bar',
    },
  },
}

export { componentDomIds }
